<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="submitBtnText()"
    :is-submit-btn="isSubmitBtn()"
    :persistent="true"
    :max-width="2000"
    :header-style="{ background: 'linear-gradient(135deg, #1f1f1f, #323232)', fontWeight: 600, color: '#fff' }"
    :submit-btn-color="'warning'"
  >
    <template slot="header">
      <span class="mr-2"
        >Scheduled Delivery{{
          item && item.request ? `: DR# ${item.request.id}` : ''
        }}</span
      >
      <v-chip
        :color="item && item.status ? item.status.color : ''"
        text-color="white"
      >
        {{ item && item.status ? item.status.name : '' }}
      </v-chip>
      <v-spacer />

      <!-- <v-tooltip v-if="item && item.request && item.request.id && (isAdmin || isDeliveriesManager)" top>
        <template #activator="{ on }">
          <v-btn
            
            icon
            medium
            v-on="on"
            @click="softDelete(item)"
          >
            <v-icon color="error">
              mdi-delete
            </v-icon>
          </v-btn>
        </template>

        <span>Delete Scheduled Delivery</span>
      </v-tooltip> -->
      <v-menu
        offset-y
        v-if="!truckRequestHasBillOfLadings(item) && (isAdmin || isDeliveriesManager)"
      >
        <template #activator="{ on, attrs }">
          <v-btn
            class="ml-1 mt-1 mb-1"
            elevation="0"
            fab
            outlined
            x-small
            v-bind="attrs"
            tile
            color="success"
            style="
              border-radius: 7px;
              width: 28px !important;
              height: 28px !important;
            "
            v-on="on"
          >
            <v-icon> mdi-dots-vertical </v-icon>
          </v-btn>
        </template>
        <v-list class="pa-3" v-if="!truckRequestHasBillOfLadings(item) && !truckRequestIsComplete(item) && !scheduledDeliveryIsCanceled(item)">
          <v-list-item
            v-if="!isArchived(item)"
            @click="openTruckRequestForm(item)">
            <v-list-item-title
              :style="`color: green; font-weight: 600;`"
            >
              <v-row align="center">
                <v-col
                  cols="auto"
                  class="pr-0"
                  style="white-space: nowrap"
                />
                <v-col class="pt-4"> EDIT </v-col>
              </v-row>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="!truckRequestHasBillOfLadings(item) && !truckRequestIsComplete(item) && scheduledDeliveryIsCanceled(item)"
            @click="softDelete(item)"
            >
            <v-list-item-title
              :style="`color: red; font-weight: 600;`"
            >
              <v-row align="center">
                <v-col
                  cols="auto"
                  class="pr-0"
                  style="white-space: nowrap"
                />
                <v-col class="pt-4"> DELETE </v-col>
              </v-row>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <template slot="body">
      <v-row class="pt-4 pb-1 px-4" dense>
        <v-col cols="12" md="3">
          <div class="meta-block">
            <div class="meta-label">
              <v-icon small class="mr-2">mdi-layers-triple-outline</v-icon>
              INVENTORY CLASSES
            </div>
            <div class="meta-value">
              <template v-for="inventoryClass in item && item.request && item.request.inventory_classes ? item.request.inventory_classes : []">
                <v-chip
                  :key="inventoryClass.id"
                  class="mt-1 mb-1 mr-1"
                  small
                  text-color="white"
                  :color="inventoryClass ? inventoryClass.color : 'white'"
                >
                  {{ inventoryClass ? inventoryClass.name : '' }}
                </v-chip>
              </template>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <div class="meta-block">
            <div class="meta-label">
              <v-icon small class="mr-2">mdi-truck-delivery-outline</v-icon>
              REQUEST TYPE
            </div>
            <div class="meta-value">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                :color="item && item.request && item.request.request_type ? item.request.request_type.color : 'white'"
              >
                {{ item && item.request && item.request.request_type ? item.request.request_type.name : '' }}
              </v-chip>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <div class="meta-block">
            <div class="meta-label">
              <v-icon small class="mr-2">mdi-truck-outline</v-icon>
              TRUCK TYPE
            </div>
            <div class="meta-value">
              <template v-for="truck_type in item && item.request ? item.request.truck_types : []">
                <v-chip
                  :key="truck_type.id"
                  class="mt-1 mb-1 mr-1"
                  small
                  text-color="white"
                  :color="truck_type ? truck_type.color : 'white'"
                >
                  {{ truck_type ? truck_type.name : '' }}
                </v-chip>
              </template>
              <!-- <v-chip
                class="mt-1 mb-1 mr-1"
                small
                text-color="white"
                :color="item && item.request && item.request.truck_type ? item.request.truck_type.color : 'white'"
              >
                {{ item && item.request && item.request.truck_type ? item.request.truck_type.name : '' }}
              </v-chip> -->
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <div class="meta-block">
            <div class="meta-label">
              <v-icon small class="mr-2">mdi-truck</v-icon>
              TRUCK
            </div>
            <div class="meta-value">
              <template v-for="truck in item && item.trucks ? item.trucks : []">
                <v-tooltip :key="truck.id" top>
                  <template #activator="{ on, attrs }">
                    <v-chip
                      v-bind="attrs"
                      v-on="on"
                      class="mt-1 mb-1 mr-1"
                      small
                      text-color="white"
                      :color="truck ? truck.color : 'white'"
                    >
                      {{ truck ? truck.name : '' }}
                    </v-chip>
                  </template>
                  <v-chip
                    small
                    text-color="white"
                    :color="truck && truck.type ? truck.type.color : 'white'"
                  >
                    {{ truck && truck.type ? truck.type.name : '' }}
                  </v-chip>
                </v-tooltip>
              </template>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <div class="meta-block">
            <div class="meta-label">
              <v-icon small class="mr-2">mdi-calendar-month-outline</v-icon>
              DELIVERY DATE
            </div>
            <div class="meta-value">
              {{ item && item.request && item.request.date ? item.request.date : '-' }}
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="3" class="mt-2">
          <div class="meta-block">
            <div class="meta-label">
              <v-icon small class="mr-2">mdi-account-outline</v-icon>
              REQUESTED BY
            </div>
            <div class="meta-value">
              {{
                item &&
                item.request &&
                item.request.created_by_user &&
                item.request.created_by_user.first_name &&
                item.request.created_by_user.last_name
                  ? `${item.request.created_by_user.first_name} ${item.request.created_by_user.last_name}`
                  : ''
              }}
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="3" class="mt-2">
          <div class="meta-block">
            <div class="meta-label">
              <v-icon small class="mr-2">mdi-clock-outline</v-icon>
              SHIFT
            </div>
            <div class="meta-value">
              <v-chip
                v-if="item && item.request && item.request.request_shift"
                small
                :color="item && item.request && item.request.request_shift ? item.request.request_shift.color : ''"
                text-color="white"
              >
                {{ item && item.request && item.request.request_shift ? item.request.request_shift.name : '' }}
              </v-chip>
              <span v-else>-</span>
              <v-menu
                v-if="(isAdmin || isDeliveriesManager) && !isArchived(item)"
                v-model="shiftMenu"
                offset-y
                left
                dark
                :close-on-content-click="true"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-tooltip top>
                    <template #activator="{ on: tipOn, attrs: tipAttrs }">
                      <v-btn
                        icon
                        v-bind="{ ...attrs, ...tipAttrs }"
                        v-on="{ ...on, ...tipOn }"
                      >
                        <v-icon medium>mdi-menu-swap</v-icon>
                      </v-btn>
                    </template>
                    <span>Change Shift</span>
                  </v-tooltip>
                </template>

                <v-list dense>
                  <v-list-item
                    v-for="shift in shifts"
                    :key="shift.id"
                    @click="onShiftChange(shift)"
                  >
                    <v-list-item-title>
                      <v-chip
                        small
                        :color="shift.color"
                        text-color="white"
                      >
                        {{ shift.name }}
                      </v-chip>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <!-- <v-tooltip top>
                <template #activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon medium>mdi-menu-swap</v-icon>
                  </v-btn>
                </template>
                <span>Change Shift</span>
              </v-tooltip> -->
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="3" class="mt-2">
          <div class="meta-block">
            <div class="meta-label">
              <v-icon small class="mr-2">mdi-package-variant</v-icon>
              CARGO
            </div>
            <div class="meta-value">
              <v-btn
                medium
                text
                color="primary"
                @click="openCargo(item)"
              >
                View Cargo
                <v-icon small class="ml-1">mdi-eye-outline</v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pb-0">
          <v-row>
            <v-col cols="12">
              <v-card elevation="0" outlined>
                <!-- <v-data-table
                  :headers="headers"
                  :items="item.requests"
                  hide-default-footer
                  :items-per-page="-1"
                  fixed-header
                  dense
                >
                  <template
                    v-for="h in headers"
                    #[`header.${h.value}`]="{ header }"
                  >
                    <v-tooltip v-if="header.fullText" :key="h.value" bottom>
                      <template #activator="{ on }">
                        <span v-on="on">{{ header.text }}</span>
                      </template>
                      <span>{{ header.fullText }}</span>
                    </v-tooltip>
                    <span v-else :key="h.value">{{ h.text }}</span>
                  </template>
                  <template #[`item.class`]="{ item }">
                    <v-chip
                      v-if="item.class"
                      small
                      :color="item && item.class ? item.class.color : ''"
                      text-color="white"
                    >
                      {{ item && item.class ? item.class.name : '' }}
                    </v-chip>
                    <span v-else>-</span>
                  </template>
                  <template #[`item.request_type`]="{ item }">
                    <v-chip
                      v-if="item.request_type"
                      small
                      :color="item && item.request_type ? item.request_type.color : ''"
                      text-color="white"
                    >
                      {{ item && item.request_type ? item.request_type.name : '' }}
                    </v-chip>
                    <span v-else>-</span>
                  </template>
                  <template #[`item.truck_types`]="{ item }">
                    <v-row
                      v-if="item.truck_types && item.truck_types.length > 1"
                    >
                      <v-col class="pl-1">
                        <v-tooltip top color="black">
                          <template #activator="{ on }">
                            <span style="color: #1976d2" v-on="on"
                              >TRUCK TYPES</span
                            >
                          </template>
                          <v-row>
                            <v-col class="text-center pt-6 pb-6">
                              <v-row
                                v-for="truck_type in item.truck_types"
                                :key="truck_type.id"
                              >
                                <v-col cols="auto" class="pr-1 pb-1 pt-1">
                                  <v-chip
                                    class="mt-1 mb-1"
                                    small
                                    text-color="white"
                                    style="cursor: pointer"
                                    :color="
                                      truck_type ? truck_type.color : 'white'
                                    "
                                  >
                                    {{ truck_type ? truck_type.name : '' }}
                                  </v-chip>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-chip
                      v-else
                      class="mt-1 mb-1"
                      small
                      text-color="white"
                      style="cursor: pointer"
                      :color="
                        item.truck_types[0]
                          ? item.truck_types[0].color
                          : 'white'
                      "
                    >
                      {{ item.truck_types[0] ? item.truck_types[0].name : '' }}
                    </v-chip>
                  </template>
                  <template #[`item.trucks`]="{ item }">
                    <v-row
                      v-if="item.trucks && item.trucks.length > 1"
                    >
                      <v-col class="pl-1">
                        <v-tooltip top color="black">
                          <template #activator="{ on }">
                            <span style="color: #1976d2" v-on="on"
                              >TRUCKS</span
                            >
                          </template>
                          <v-row>
                            <v-col class="text-center pt-6 pb-6">
                              <v-row
                                v-for="truck in item.trucks"
                                :key="truck.id"
                              >
                                <v-col cols="auto" class="pr-1 pb-1 pt-1">
                                  <v-chip
                                    class="mt-1 mb-1"
                                    small
                                    text-color="white"
                                    style="cursor: pointer"
                                    :color="
                                      truck ? truck.color : 'white'
                                    "
                                  >
                                    {{ truck ? truck.name : '' }}
                                  </v-chip>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-chip
                      v-else-if="item.trucks.length > 0"
                      class="mt-1 mb-1"
                      small
                      text-color="white"
                      style="cursor: pointer"
                      :color="
                        item.trucks[0]
                          ? item.trucks[0].color
                          : 'white'
                      "
                    >
                      {{
                        item.trucks[0] ? item.trucks[0].name : ''
                      }}
                    </v-chip>
                    <span v-else>
                      -
                    </span>
                  </template>
                  <template #[`item.project.name`]="{ item }">
                    {{ item.project ? item.project.name : '-' }}
                  </template>
                  <template #[`item.job.full_name`]="{ item }">
                    <span v-if="item.job">
                      <span style="font-weight: bold">{{
                        item.job.code ? `${item.job.code}` : ''
                      }}</span>
                      -
                      {{
                        item.project
                        ? item.project.name
                        : ''
                      }}
                      <span style="color: #1976d2">{{
                        item.job.reference ? `; ${item.job.reference}` : ''
                      }}</span>
                    </span>
                    <span v-else>-</span>
                  </template>
                  <template #[`item.request_shift`]="{ item }">
                    <v-chip
                      v-if="item.request_shift"
                      small
                      :color="item && item.request_shift ? item.request_shift.color : ''"
                      text-color="white"
                    >
                      {{ item && item.request_shift ? item.request_shift.name : '' }}
                    </v-chip>
                    <span v-else>-</span>
                  </template>
                  <template #[`item.status.name`]="{ item }">
                    <v-chip
                      small
                      :color="item && item.status ? item.status.color : ''"
                      text-color="white"
                    >
                      {{ item && item.status ? item.status.name : '' }}
                    </v-chip>
                  </template>
                  <template #[`item.windows`]="{ item }">
                    {{
                      `${item.current_finished_goods_count}/${item.total_finished_goods_count}`
                    }}
                  </template>
                  <template #[`item.created_by_user`]="{ item }">
                    {{
                      item.created_by_user &&
                      item.created_by_user.first_name &&
                      item.created_by_user.last_name
                        ? `${item.created_by_user.first_name} ${item.created_by_user.last_name}`
                        : ''
                    }}
                  </template>
                  <template #[`item.pick_list_status`]="{ item }">
                    <v-tooltip
                      v-if="item.pick_lists && item.pick_lists.length > 1"
                      top
                      color="black"
                    >
                      <template #activator="{ on }">
                        <span class="ml-1" style="color: #1976d2" v-on="on">STATUSES</span>
                      </template>
                      <template v-for="p in item.pick_lists">
                        <span v-if="!isBackorderPickList(p)" :key="p.id">
                          <span class="mt-1">
                            {{ p.code }}
                          </span>
                          <v-chip
                            small
                            :color="p.status ? p.status.color : ''"
                            class="ml-1 mt-1"
                            text-color="white"
                          >
                            {{ p.status.name ? p.status.name : '' }}
                          </v-chip>
                          <span v-if="p.created_backorder && p.created_backorder.backorder_part_pick_list">
                            <span class="mdi mdi-arrow-right ml-1"></span>
                            {{ p.created_backorder.backorder_part_pick_list.code }}
                            <v-chip
                              small
                              :color="p.created_backorder.backorder_part_pick_list.status ? p.created_backorder.backorder_part_pick_list.status.color : ''"
                              class="ml-1 mt-1"
                              text-color="white"
                            >
                              {{ p.created_backorder.backorder_part_pick_list.status.name ? p.created_backorder.backorder_part_pick_list.status.name : '' }}
                            </v-chip>
                          </span>
                          <br />
                        </span>
                      </template>
                    </v-tooltip>
                    <span class="ml-1" v-else-if="item.pick_lists && item.pick_lists.length === 1">
                      {{ item.pick_lists[0].code }}
                      <v-chip
                        small
                        :color="
                          item &&
                          item.pick_lists &&
                          item.pick_lists[0] &&
                          item.pick_lists[0].status
                            ? item.pick_lists[0].status.color
                            : ''
                        "
                        class="ml-1"
                        text-color="white"
                      >
                        {{
                          item &&
                          item.pick_lists &&
                          item.pick_lists[0] &&
                          item.pick_lists[0].status.name
                            ? item.pick_lists[0].status.name
                            : ''
                        }}
                      </v-chip>
                      <span v-if="item.pick_lists[0].created_backorder && item.pick_lists[0].created_backorder.backorder_part_pick_list">
                        <span class="mdi mdi-arrow-right ml-1"></span>
                        {{ item.pick_lists[0].created_backorder.backorder_part_pick_list.code }}
                        <v-chip
                          small
                          :color="item.pick_lists[0].created_backorder.backorder_part_pick_list.status ? item.pick_lists[0].created_backorder.backorder_part_pick_list.status.color : ''"
                          class="ml-1"
                          text-color="white"
                        >
                          {{ item.pick_lists[0].created_backorder.backorder_part_pick_list.status.name ? item.pick_lists[0].created_backorder.backorder_part_pick_list.status.name : '' }}
                        </v-chip>
                      </span>
                    </span>
                    <span v-else>-</span>
                  </template>
                  <template #[`item.actions`]="{ item }">
                    <v-btn
                      class="ml-1 mt-1 mb-1"
                      color="primary"
                      outlined
                      small
                      @click="openTruckRequestForm(item, true)"
                    >
                      VIEW
                    </v-btn>
                    <v-btn
                      v-if="item.request_shift_id !== truckScheduleRequestShiftIdPending && item.request_type_id === truckScheduleRequestTypeIdPickup && item.status_id !== truckScheduleStatusIdComplete"
                      class="ml-1 mt-1 mb-1"
                      color="primary"
                      outlined
                      small
                      @click="completeTruckRequest(item)"
                    >
                      COMPLETE
                    </v-btn>
                    <v-btn
                      v-if="item.status_id == truckScheduleRequestStatusIdScheduled && (isDeliveriesManager || isAdmin)"
                      class="ml-1 mt-1 mb-1 mr-1"
                      color="purple"
                      outlined
                      small
                      @click="openManualScheduleForm(item)"
                    >
                      RESCHEDULE
                    </v-btn>
                    <v-btn
                      v-if="item.bill_of_ladings.length > 0"
                      class="ml-1 mt-1 mb-1"
                      color="success"
                      outlined
                      small
                      @click="openBillOfLadingList(item)"
                    >
                      BOL
                    </v-btn>
                    <v-btn
                      v-if="
                        (isDeliveriesManager || isAdmin) &&
                        !truckRequestHasBillOfLadings(item) &&
                        !truckRequestIsComplete(item)
                      "
                      class="ml-1 mt-1 mb-1 mr-1"
                      color="error"
                      outlined
                      small
                      @click="cancel(item)"
                    >
                      CANCEL
                    </v-btn>
                  </template>
                </v-data-table> -->
                <div class="dr-tabs-row">
                  <v-tabs
                    v-model="activeTab"
                    background-color="transparent"
                    color="black"
                    slider-color="black"
                  >
                    <v-tab
                      v-for="(tab, index) in tabs"
                      :key="index"
                    >
                      <v-icon small class="mr-2">
                        {{ tab.icon }}
                      </v-icon>

                      {{ tab.label }}

                      <v-badge
                        class="ml-2"
                        :content="tab.count"
                        inline
                        color="black"
                      />

                      <!-- <v-icon>
                        mdi-note-text
                      </v-icon>

                      <v-badge
                        :content="tab.noteCount"
                        inline
                        color="black"
                      /> -->
                    </v-tab>
                  </v-tabs>
                </div>

                <v-divider />

                <v-tabs-items v-model="activeTab">
                  <v-tab-item>
                    <v-data-table
                      :headers="jobHeaders"
                      :items=" item && item.request && item.request.jobs ? item.request.jobs : []"
                      hide-default-footer
                      class="dr-table"
                    >
                      <template
                        v-for="h in headers"
                        #[`header.${h.value}`]="{ header }"
                      >
                        <v-tooltip v-if="header.fullText" :key="h.value" top>
                          <template #activator="{ on }">
                            <span v-on="on">{{ header.text }}</span>
                          </template>
                          <span>{{ header.fullText }}</span>
                        </v-tooltip>
                        <span v-else :key="h.value">{{ h.text }}</span>
                      </template>
                      <template #[`item.inventory_class`]="{ item }">
                        <v-chip
                          small
                          :color="item && item.class ? item.class.color : 'black'"
                          text-color="white"
                        >
                          {{ item && item.class ? item.class.name : '' }}
                        </v-chip>
                      </template>
                      <template #[`item.job`]="{ item }">
                        <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.project ? item.project.name : item.name }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
                      </template>
                      <template #[`item.note`]="{ item }">
                        <v-textarea
                          :readonly="!isAdmin && !isDeliveriesManager && !isArchived(item)"
                          v-model="item.note"
                          rows="1"
                          auto-grow
                        />
                      </template>
                      <template #[`item.ready_to_be_shipped_finished_goods`]="{ item }">
                        {{
                          item.ready_to_be_shipped_finished_goods_count > 0 ? item.ready_to_be_shipped_finished_goods_count : '-'
                        }}
                      </template>
                      <template #[`item.shipped_finished_goods`]="{ item }">
                        {{
                          item.shipped_finished_goods_count > 0 ? item.shipped_finished_goods_count : '-'
                        }}
                      </template>
                      <template #[`item.total_finished_goods`]="{ item }">
                        {{
                          item.total_finished_goods_count > 0 ? item.total_finished_goods_count : '-'
                        }}
                      </template>
                      <!-- <template #[`item.windows`]="{ item }">
                        {{
                          `${item.current_finished_goods_count}/${item.total_finished_goods_count}`
                        }}
                      </template> -->
                      <template #[`item.bill_of_ladings`]="{ item }">
                        <v-btn
                          v-if="item.bill_of_ladings && item.bill_of_ladings.length > 0"
                          class="ml-1 mt-1 mb-1"
                          color="success"
                          outlined
                          small
                          @click="openBillOfLadingList(item)"
                        >
                          BOL
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                  <v-tab-item>
                    <v-data-table
                      :headers="projectHeaders"
                      :items=" item && item.request && item.request.projects ? item.request.projects : []"
                      hide-default-footer
                      class="dr-table"
                    >
                      <template #[`item.note`]="{ item }">
                        <v-textarea
                          v-model="item.note"
                          :readonly="!isAdmin && !isDeliveriesManager && !isArchived(item)"
                          rows="1"
                          auto-grow
                        />
                      </template>
                    </v-data-table>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-col>
          </v-row>
          <!-- <v-spacer />
          <v-row>
            <v-col>
              <v-row align="center">
                <v-col class="pb-0">
                  <span :style="{ color: '#000000', fontSize: '18px' }"
                    >Notes</span
                  >
                </v-col>
                <v-col v-if="item.id" class="text-end">
                  <v-btn color="orange" outlined @click="openNoteForm">
                    SEE ALL NOTES
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0">
                  <v-textarea
                    v-model="item.note"
                    :disabled="item.notes && item.notes.length > 0"
                    outlined
                    rows="3"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row> -->
        </v-col>
      </v-row>
      <truck-schedule-request-form
        ref="truckScheduleRequestForm"
        @success="updateSuccess"
      />
      <truck-schedule-bill-of-lading-list-form ref="billOfLadingList" />
      <truck-schedule-manual-schedule-form
        ref="truckScheduleManualScheduleForm"
        @success="success"
      />
      <note-form v-show="false" ref="noteForm" />
      <confirm-form ref="confirmForm" />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TruckScheduleRequestForm from '@/components/forms/truckSchedules/TruckScheduleRequestForm';
import TruckScheduleBillOfLadingListForm from '@/components/forms/truckSchedules/TruckScheduleBillOfLadingListForm';
import TruckScheduleManualScheduleForm from '@/components/forms/truckSchedules/TruckScheduleManualScheduleForm';
import NoteForm from '@/components/forms/notes/NoteForm';

export default {
  components: {
    TruckScheduleRequestForm,
    TruckScheduleBillOfLadingListForm,
    TruckScheduleManualScheduleForm,
    NoteForm,
  },
  props: {},
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      date: null,
      requests: [],
      note: null,
    },
    roles: [],
    shifts: [],
    headers: [
      { text: 'Class', value: 'class', width: '3%', align: 'center' },
      { text: 'ID', value: 'id', width: '5%', align: 'center' },
      { text: 'Type', value: 'request_type', width: '5%', align: 'center' },
      { text: 'Project', value: 'project.name', width: '10%' },
      { text: 'WO#', value: 'job.full_name', width: '10%' },
      {
        text: 'Truck Types',
        value: 'truck_types',
        width: '5%',
        align: 'center',
      },
      {
        text: 'Trucks',
        value: 'trucks',
        width: '5%',
        align: 'center',
      },
      { text: 'Requested Delivery Date', value: 'date', width: '5%' },
      { text: 'Requested By', value: 'created_by_user', width: '5%' },
      {
        text: 'Shift',
        value: 'request_shift',
        width: '5%',
        align: 'center',
      },
      { text: 'Status', value: 'status.name', width: '5%', align: 'center' },
      {
        fullText: "Total Shipped or Received Windows for This Job / Total Windows for This Job",
        text: 'Window Ct. / Tot. Window Ct.',
        value: 'windows',
        width: '10%',
        align: 'center',
      },
      {
        text: 'Pick List Status',
        value: 'pick_list_status',
        width: '17%',
        align: 'center',
      },
      {
        text: 'Actions',
        value: 'actions',
        align: 'end',
        width: '10%',
        sortable: false,
      },
    ],
    activeTab: 0,
    // jobHeaders: [
    //   { text: "Class", value: "inventory_class", align: "center", width: "5%", sortable: false },
    //   { text: "WO#", value: "code", width: "5%", sortable: false },
    //   { text: "Job", value: "job", width: "20%", sortable: false  },
    //   { text: "Note", value: "note", width: "55%", sortable: false  },
    //   {
    //     fullText: "Total Shipped or Received Windows for This Job / Total Windows for This Job",
    //     text: 'Window Ct. / Tot. Window Ct.',
    //     value: 'windows',
    //     width: '10%',
    //     align: 'center',
    //   },
    //   { text: "", value: "bill_of_ladings", width: "5%", align: "center", sortable: false  },
    // ],
    projectHeaders: [
      { text: 'Project Name', value: 'name', width: '15%', sortable: false },
      { text: "Note", value: "note", width: "85%", sortable: false  },
    ],
    userRoleIdAdmin: 3,
    userRoleIdDeliveriesManager: 31,
    noteTypeIdTruckScheduleScheduledDelivery: 5,
    pickListStatusIdPartiallySupplied: 2,
    pickListStatusIdSupplied: 3,
    pickListStatusIdShipped: 4,
    truckScheduleRequestTypeIdPickup: 1,
    truckScheduleRequestTypeIdNonWindowDelivery: 3,
    truckScheduleRequestShiftIdPending: 1,
    truckScheduleRequestStatusIdScheduled: 2,
    truckScheduleStatusIdComplete: 8,
    truckScheduleStatusIdCanceled: 10,
    shiftMenu: false,
  }),
  watch: {},
  computed: {
    ...mapState({
      user: (state) => state.user,
      isDarkMode: 'isDarkMode',
    }),
    ...mapGetters([]),
    isAdmin() {
      return this.roles.includes(this.userRoleIdAdmin);
    },
    isDeliveriesManager() {
      return this.roles.includes(this.userRoleIdDeliveriesManager);
    },
    tabs() {
      if (!this.item || !this.item.request) return [];

      const showProjects = this.item.request.request_type_id === this.truckScheduleRequestTypeIdPickup || this.item.request.request_type_id === this.truckScheduleRequestTypeIdNonWindowDelivery;

      const tabs = [
        {
          key: "jobs",
          label: "Jobs",
          icon: "mdi-briefcase-outline",
          count: this.item && this.item.request && this.item.request.jobs ? this.item.request.jobs.length.toString() : "0",
          noteCount: this.item && this.item.request && this.item.request.jobs ? this.item.request.jobs.filter(j => j.note && j.note.trim().length > 0).length.toString() : "0",
        },
      ]

      if (showProjects) {
        tabs.push(
          {
            key: "projects",
            label: "Projects",
            icon: "mdi-ruler",
            count: this.item && this.item.request && this.item.request.projects ? this.item.request.projects.length.toString() : "0",
            noteCount: this.item && this.item.request && this.item.request.projects ? this.item.request.projects.filter(p => p.note && p.note.trim().length > 0).length.toString() : "0",
          }
        );
      }

      return tabs;
    },
    jobHeaders() {
      const headers = [
      { text: "Class", value: "inventory_class", align: "center", width: "5%", sortable: false },
      { text: "WO#", value: "code", width: "5%", sortable: false },
      { text: "Job", value: "job", width: "15%", sortable: false  },
      { text: "Note", value: "note", width: "50%", sortable: false  },
      { fullText: "Total Ready to be Shipped Finished Goods Count", text: 'Ready to Ship Ct.', value: 'ready_to_be_shipped_finished_goods_count', width: '5%', align: 'center' },
      { fullText: "Total Shipped Finished Goods Count", text: 'Shipped Ct.', value: 'shipped_finished_goods_count', width: '5%', align: 'center' },
      { fullText: "Total Finished Goods Count", text: 'Total Ct.', value: 'total_finished_goods_count', width: '5%', align: 'center' },
      // {
      //   fullText: "Total Shipped or Received Windows for This Job / Total Windows for This Job",
      //   text: 'Window Ct. / Tot. Window Ct.',
      //   value: 'windows',
      //   width: '10%',
      //   align: 'center',
      // },
      // { text: "", value: "bill_of_ladings", width: "5%", align: "center", sortable: false  },
    ];
      if (this.item.request && this.item.request.jobs && this.item.request.jobs.some(j => j.bill_of_ladings && j.bill_of_ladings.length > 0)) {
        headers.push({ text: "", value: "bill_of_ladings", width: "5%", align: "center", sortable: false  });
      }
      return headers;
    }
  },
  watch: {},
  created() {
    this.roles = this.user.roles.map((x) => x.id);
    this.item = JSON.parse(JSON.stringify(this.itemDto));
    this.init();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    async init() {
      this.getShifts();
    },

    async open(id) {
      this.$bus.$emit('loading');
      this.$refs.dialogBox.open();
      if (id) {
        const res = await this.get(id);
        if (!res) {
          this.$refs.dialogBox.close();
          this.$bus.$emit('loading-stop');
          this.$bus.$emit('showError', 'Scheduled delivery not found');
          return;
        }
      } else {
        this.item = JSON.parse(JSON.stringify(this.itemDto));
      }
      this.$bus.$emit('loading-stop');
    },

    async get(id) {
      const submitModel = {
        filters: {
          id,
        },
        // with: ['request_pick_lists']
      };
      const res = await this.$api.truckScheduleSlot.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res) {
        this.$bus.$emit('showError', 'Unable to retrieve delivery requests');
        return false;
      }

      const firstIndex = 0;
      this.item = JSON.parse(JSON.stringify(res[firstIndex]));
      return true;
    },

    async getShifts() {
      const res = await this.$api.truckScheduleRequestShift.get();
      if (!res) return;
      this.shifts = res;
    },

    async submit() {
      this.$bus.$emit('loading');
      let res = false;

      if (!this.item || !this.item.id) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error, no scheduled delivery to update');
        return false;
      }

      res = await this.$api.truckScheduleSlot.update(this.item, 'update-notes');

      if (!res) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error submitting scheduled delivery');
        return false;
      }

      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return true;
    },

    async onShiftChange(shift) {
      this.item.request.request_shift = shift;
      this.item.request.request_shift_id = shift.id;
      //send request to back-end to update shift for this truck request
      this.$bus.$emit('loading');
      const res = await this.$api.truckScheduleRequest.update(this.item.request);
      this.$bus.$emit('loading-stop');
      if (!res) {
        this.$bus.$emit('showError', 'Unable to update Delivery Request Shift');
        return false;
      }
      this.$bus.$emit('showSuccess', 'Delivery Request Shift Updated');
      //then finally, update the parent component to update the slot in the calendar and truck request in the datatable
      this.$emit('success');
      this.shiftMenu = false;
    },

    // async remove(item) {
    //   const confirm = await this.$refs.confirmForm.open({
    //     title: 'Are you sure that you want to remove this record?',
    //   });
    //   if (!confirm) return;
    //   //disassociate truck request from scheudled delivery and change the status back to 'NOT ASSIGNED'
    //   console.log('removed item: ', item);

    //   const itemIndex = this.item.requests.findIndex((x) => {
    //     return x.id === item.id;
    //   });

    //   if (itemIndex >= 0) {
    //     this.item.requests.splice(itemIndex, 1);
    //   }
    // },

    async cancel(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to cancel this truck request?',
      });
      if (!confirm) return;
      //disassociate truck request from scheudled delivery and change the status back to 'NOT ASSIGNED'
      
      const itemIndex = this.item.requests.findIndex((x) => {
        return x.id === item.id;
      });

      if (itemIndex >= 0) {
        this.item.requests.splice(itemIndex, 1);
      }
    },

    openBillOfLadingList(item) {
      this.$refs.billOfLadingList.open(item);
    },

    openNoteForm() {
      this.$refs.noteForm.open(
        this.item.id,
        this.noteTypeIdTruckScheduleScheduledDelivery
      );
    },

    submitBtnText() {
      return "Update Notes"
    },

    isSubmitBtn() {
      if (!this.isAdmin && !this.isDeliveriesManager) return false;
      return !!this.item.id;
    },

    truckRequestHasBillOfLadings(scheduledDelivery) {
      return scheduledDelivery && scheduledDelivery.request && scheduledDelivery.request.bill_of_ladings && scheduledDelivery.request.bill_of_ladings.length > 0;
    },

    truckRequestHasSuppliedPickList(scheduledDelivery) {
      return scheduledDelivery && scheduledDelivery.request && scheduledDelivery.request.pick_list && (scheduledDelivery.request.pick_list.status_id === this.pickListStatusIdSupplied || scheduledDelivery.request.pick_list.status_id === this.pickListStatusIdPartiallySupplied || scheduledDelivery.request.pick_list.status_id === this.pickListStatusIdShipped);
    },

    truckRequestIsComplete(scheduledDelivery) {
      return scheduledDelivery && scheduledDelivery.request && scheduledDelivery.request.status_id === this.truckScheduleStatusIdComplete;
    },

    scheduledDeliveryIsCanceled(scheduledDelivery) {
      return scheduledDelivery && scheduledDelivery.status_id === this.truckScheduleStatusIdCanceled;
    },

    openManualScheduleForm(item) {
      this.$refs.truckScheduleManualScheduleForm.open(item);
    },

    openCargo(item) {
      if (!item) {
        this.$bus.$emit('showError', 'Unable to open cargo, no item found');
        return;
      }
      const step = 3; //open to cargo step
      const options = {
        isView: true,
        step: step,
      }
      this.$refs.truckScheduleRequestForm.open(item.truck_schedule_request_id, options);
    },

    async updateSuccess() {
      this.get(this.item.id);
      this.$emit('success');
    },

    async success() {
      this.$bus.$emit('loading');
      await this.get(this.item.id);
      //if no more truck requests, then close and delete scheduled delivery
      if (this.item.requests.length === 0) {
        const res = await this.$api.truckScheduleSlot.delete(this.item.id);
        this.$bus.$emit('loading-stop');
        if (!res) {
          this.$bus.$emit('showError', 'Error deleting scheduled delivery');
          return false;
        }
        this.$refs.dialogBox.close();
      }
      this.$bus.$emit('loading-stop');
      //if there are still truck requests then don't do anything;

      // this.$refs.dialogBox.close();
      // this.$emit('success');
      this.$emit('success');
    },

    async completeTruckRequest(item) {
      if(!item) return;
      if(item.request_type_id !== this.truckScheduleRequestTypeIdPickup) {
        this.$bus.$emit('showError', 'Only Pickup Truck Requests can be completed');
        return;
      }
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to complete this Pickup Truck Request?',
      });
      if (!confirm) return;
      const res = await this.$api.truckScheduleRequest.get(`complete/${item.id}`);
      if (!res) {
        this.$bus.$emit('showError', 'Error completing truck request');
        return;
      }
      this.$bus.$emit('showSuccess');
    },

    async softDelete(item) {
      if(!item) return;
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this Scheduled Delivery?',
      });
      if (!confirm) return;
      const res = await this.$api.truckScheduleSlot.delete(`${item.id}`);
      if (!res) {
        this.$bus.$emit('showError', 'Error deleting scheduled delivery');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.$emit('success');
    },

    openTruckRequestForm(item, isView = false) {
      if (!item) {
        this.$bus.$emit('showError', 'Unable to open delivery request, no item found');
        return;
      }
      this.$refs.truckScheduleRequestForm.open(item.truck_schedule_request_id);
    },

    isNewNote(note) {
      if (!this.item.latest_note) return true;
      return this.item.latest_note.text !== note;
    },

    isBackorderPickList(pickList) {
      return pickList && pickList.backorder_id > 0;
    },

    isArchived(item) {
      return item && item.request && item.request.is_archived;
    },
  },
};
</script>
<style scoped>
.meta-block {
  padding: 10px 0;
}
.meta-label {
  display: flex;
  align-items: center;
  font-weight: 700;
  letter-spacing: 1.2px;
  color: #7b7b7b;
  text-transform: uppercase;
}
.meta-value {
  margin-top: 6px;
  font-size: 16px;
  font-weight: 600;
  color: #111;
}

.dr-tabs {
  min-height: 48px;
}

/* Table */
::v-deep .dr-table .v-data-table__wrapper table thead.v-data-table-header tr th {
  background-color: transparent;
  height: 32px;
}
::v-deep .dr-table .v-data-table__wrapper table thead.v-data-table-header tr th span {
  color: #7b7b7b;
}
::v-deep .dr-table td {
  font-size: 15px;
}
</style>